import { useEffect, useState } from 'react';
import { formatSecondDuration, sessionStatusEnums } from 'utils';

export const SessionTimer = ({ sessionById, convertByText }) => {
    const [time, setTime] = useState(0);

    useEffect(() => {
        let intervalId = null;
        if (sessionById) {
            const played = sessionById.events?.at(-1)?.status === sessionStatusEnums.IN_PROGRESS;
            if (played) {
                const eventTime = new Date(sessionById.events?.at(-1)?.datetime).getTime();
                const now = Date.now();
                const secondsElapsed = Math.floor((now - eventTime) / 1000);
                setTime(sessionById.totalDuration + secondsElapsed);
            } else {
                setTime(sessionById.totalDuration);
            }
            if (played) {
                intervalId = setInterval(() => {
                    setTime((prev) => {
                        return prev + 1;
                    });
                }, 1000);
            }
        }
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [sessionById]);

    return formatSecondDuration(time, convertByText);
};
